// extracted by mini-css-extract-plugin
export default {"subTitle":"dataPurpose_subTitle__ITsp5","dataWrapper":"dataPurpose_dataWrapper__r3+3e"};